










































































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import SlideIn from '@/components/basic/SlideIn.vue';
import StToggle from '@/components/basic/StToggle.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StSearch from '@/components/basic/StSearch.vue';
import { UserStore } from '@/store/user-module';
import { AccountStore } from '@/store/account-module';
import {stAccountApi} from '@/services/st-api';

@Component({
  components: {
    StSearch,
    StInput2,
    StToggle,
    SlideIn,
  },
})
export default class St2Migration extends Vue {
  private loading = false;
  private result: any = null;

  get userSettings() {
    return UserStore.userSettings;
  }

  mounted() {
    UserStore.reloadStore();
  }

  async upgrade() {
    this.loading = true;

    await stAccountApi.upgradeAccount();

    this.$dialog.alert({
      title: 'Inaktiv',
      text: 'Der vollständige Wechsel zu SpikeTime 3 kann noch nicht abgeschlossen werden - wir geben in Kürze via E-Mail Bescheid, sobald der Wechsel verfügbar ist. ',
      variant: 'success',
    });

    this.loading = false;
  }
}
